import { createContext, PropsWithChildren, useContext } from 'react';

import { useCitationFileParagraphsQuery } from './graphql/FileParagraphPicker.generated';

const FileParagraphsContext = createContext<ReturnType<
  typeof useCitationFileParagraphsQuery
> | null>(null);

/** Shares extracted text between Find and citation selection for one file. */
export function FileParagraphsProvider({
  fileID,
  enabled = true,
  processing = false,
  children,
}: PropsWithChildren<{
  fileID: string;
  enabled?: boolean;
  processing?: boolean;
}>) {
  const result = useCitationFileParagraphsQuery({
    variables: { fileID },
    skip: !enabled || processing,
    // Large polygon trees exceed Apollo's result memo limits. Keep this
    // file-scoped result out of cache broadcasts from unrelated subscriptions.
    fetchPolicy: 'no-cache',
  });

  return (
    <FileParagraphsContext.Provider
      value={
        processing ? { ...result, data: undefined, loading: true } : result
      }
    >
      {children}
    </FileParagraphsContext.Provider>
  );
}

export function useFileParagraphs() {
  const result = useContext(FileParagraphsContext);
  if (!result) throw new Error('FileParagraphsProvider is required');
  return result;
}
